module.exports = __webpack_public_path__ + "img/wiki-home-bg.e9d4bb85.png";